module.exports = __webpack_public_path__ + "img/services-case2.60237e7e.png";